import React from 'react';

const PersonIcon = ({ color = 'currentColor' }) => (
  <svg aria-hidden={true} width="18" height="18" fill="none" viewBox="0 0 24 22">
    <path stroke={color} strokeWidth={2} strokeLinecap="round" d="M5 20V19C5 15.134 8.13401 12 12 12V12C15.866 12 19 15.134 19 19V20" />
    <path stroke={color} strokeWidth={2} strokeLinecap="round" d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z" />
  </svg>

);

export default PersonIcon;